import { FC } from "react";
import CONSTANTS from "../constants/constants.json";
import "./styles/page.css";

const {
  SITE_META,
  ABOUT_DATA,
  CONTACT_DATA,
  EXPERIENCE_DATA,
  SKILLS_DATA,
  EDUCATION_DATA,
  RESEARCH_DATA,
  COMPETITIVE_PLATFORMS,
  certifications
} = CONSTANTS;

const HomePage: FC = () => {
  return (
    <div className="page">
      {/* Bio */}
      <h1 className="page-name">{ABOUT_DATA.NAME}</h1>
      <p className="page-title">{ABOUT_DATA.INTRO}</p>
      <p className="page-bio">{ABOUT_DATA.BIO}</p>
      <div className="social-row">
        {COMPETITIVE_PLATFORMS.map((platform) => (
          <a
            key={platform.label}
            href={platform.url}
            target="_blank"
            rel="noopener noreferrer"
            className="social-item social-item--platform"
          >
            {platform.label}
          </a>
        ))}
      </div>
      <div className="social-row">
        {CONTACT_DATA.map((link) => (
          <a
            key={link.label}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="social-item"
          >
            <i className={link.icon}></i>
            <span>{link.label}</span>
          </a>
        ))}
      </div>

      {/* Work Experience */}
      <section className="home-section">
        <h2 className="home-section-heading">
          {SITE_META.HOME_SECTIONS.EXPERIENCE}
        </h2>
        <ul className="exp-list">
          {EXPERIENCE_DATA.EXPERIENCES.map((exp) => (
            <li key={exp.ID} className="exp-item">
              <div className="exp-header">
                <span className="exp-company">{exp.COMPANY}</span>
                <span className="exp-duration">{exp.DURATION}</span>
              </div>
              <div className="exp-meta">
                <span className="exp-position">{exp.POSITION}</span>
                <span className="exp-location">{exp.LOCATION}</span>
              </div>
              <ul className="bullet-list">
                {exp.BULLETS.map((point, i) => (
                  <li key={i} className="bullet-item">
                    {point}
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </section>

      {/* Skills */}
      <section className="home-section">
        <h2 className="home-section-heading">
          {SITE_META.HOME_SECTIONS.SKILLS}
        </h2>
        <div className="skills-grid">
          {SKILLS_DATA.GROUPS.map((group) => (
            <div key={group.LABEL} className="skill-group">
              <span className="skill-label">{group.LABEL}</span>
              <span className="skill-items">{group.ITEMS.join(", ")}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Certifications */}
      <section className="home-section">
        <h2 className="home-section-heading">
          {SITE_META.HOME_SECTIONS.CERTIFICATIONS}
        </h2>
        <ul className="cert-list">
          {certifications.map((cert) => (
            <li key={cert.title} className="cert-item">
              <span className="cert-title">{cert.title}</span>
              <span className="cert-date">{cert.date}</span>
            </li>
          ))}
        </ul>
      </section>

      {/* Education */}
      <section className="home-section">
        <h2 className="home-section-heading">
          {SITE_META.HOME_SECTIONS.EDUCATION}
        </h2>
        <ul className="edu-list">
          {EDUCATION_DATA.EDUCATION.map((edu) => (
            <li key={edu.SERIAL_NO} className="edu-item">
              <div className="edu-header">
                <span className="edu-university">{edu.UNIVERSITY}</span>
                <span className="edu-location">{edu.LOCATION}</span>
              </div>
              <p className="edu-degree">
                {edu.DEGREE} &middot; {edu.MAJOR}
              </p>
              <p className="edu-marks">{edu.MARKS}</p>
            </li>
          ))}
        </ul>
      </section>

      {/* Research */}
      <section className="home-section">
        <h2 className="home-section-heading">
          {SITE_META.HOME_SECTIONS.RESEARCH}
        </h2>
        <ul className="research-list">
          {RESEARCH_DATA.PUBLICATIONS.map((pub) => (
            <li key={pub.TITLE} className="research-item">
              <div className="research-header">
                <span className="research-title">{pub.TITLE}</span>
              </div>
              <p className="research-journal">{pub.JOURNAL}</p>
              <p className="research-tech">{pub.TECHNOLOGIES.join(" · ")}</p>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default HomePage;
